import React from 'react';
import { useEvent } from '../../../../../data/hooks/eventHooks';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useIsEventParticipantsLoaded } from '../../../../../data/hooks/participant/useIsEventParticipantsLoaded';
import SectionLinkedHeader from '../../../../elements/SectionHeader/SectionLinkedHeader/SectionLinkedHeader';
import LoadParticipants from '../../../../loaders/LoadParticipants';
import styles from './HomeEventParticipants.module.scss';
import HomeEventParticipantsList from './HomeEventParticipantsList/HomeEventParticipantsList';
import HomeEventParticipantsPlaceholder from './HomeEventParticipantsPlaceholder/HomeEventParticipantsPlaceholder';
import { useEventSettings } from '../../../../../data/hooks/events/useEventSettings';

const PARTICIPANTS_COUNT = 5;

const HomeEventParticipants = (props) => {
    const { eventId } = props,
        event = useEvent(eventId),
        { show_participants_on_home } = event,
        { disable_participants_list } = useEventSettings(eventId),
        i18n = useI18n(),
        loaded = useIsEventParticipantsLoaded(event.id),
        participantsLink = ['/events', event.id, 'participants'].join('/');

    if (disable_participants_list) return null;
    if (show_participants_on_home === false) return null;

    return (
        <LoadParticipants eventId={eventId}>
            <div
                className={[styles.HomeEventParticipants, 'content striped'].join(' ')}
                onClick={() => {
                    app.history.push(participantsLink);
                }}>
                <SectionLinkedHeader href={participantsLink} color={event.settings.primary_color} next>
                    {event._isCommunity ? i18n['label.community-participants'] : i18n['label.participants']}
                </SectionLinkedHeader>
                <div className={[styles.content, 'text-center'].join(' ')}>
                    {loaded ? (
                        <HomeEventParticipantsList eventId={eventId} avatarClassName={styles.avatar} size={PARTICIPANTS_COUNT} />
                    ) : (
                        <HomeEventParticipantsPlaceholder avatarClassName={styles.avatar} participantsLink={participantsLink} size={PARTICIPANTS_COUNT} />
                    )}
                </div>
            </div>
        </LoadParticipants>
    );
};

export default HomeEventParticipants;
